export const currentAllPlaylistIdAPI = [
  ["Rose's Playlist", "u_HUK_Eo13DdwHS06Rhp1"],
  ["Perry XD", "-U8gqX-68QzzMgU1PfXi7"],
  ["Friday Night", "AOkZff39gEd8EsJoUD9x0"],
];
